/**
 * UTM -> window.mwfUtmData helper
 */
class MWF_UTM {
	constructor() {
    this.utmResults = {
      'utm_content': null,
      'utm_campaign': null,
      'utm_medium': null,
      'utm_source': null,
      'gclid': null
    };

    window.mwfUtmData = window.mwfUtmData || {};

    this.parseUtmsInUrl();
    this.setReferrer();
    this.setUtmData();
  }

  parseUtmsInUrl () {
    let query = window.location.href;
          
    if (query.indexOf('?') != -1){
      query = query.split('?');		
      query = query[1];
    }

    let parsedQuery = query.split("&");
    let allowedKeys = Object.keys(this.utmResults);

    for (var i = 0; i < parsedQuery.length; i++) {
      let pair = parsedQuery[i].split('=');
      let key = decodeURIComponent(pair[0]);

      if (key.length === 0 || allowedKeys.indexOf(key) === -1) {
        continue;
      }

      let value = decodeURIComponent(pair[1].replace("+"," "));
      this.utmResults[key] = value;
    }
  };

  setReferrer () {
    this.utmResults.referrer = document.referrer;

    if (!!this.utmResults.referrer) {
      this.utmResults.referrer = this.utmResults.referrer.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
      this.utmResults.referrer = this.utmResults.referrer.replace(/[^a-z0-9\-\_\.\/\+\@\?\&ąćęłńóśźż]/gmi, '');
    } else {
      this.utmResults.referrer = null;
    }

    if (this.utmResults.referrer === window.location.host) {
      this.utmResults.referrer = null;
    }
  }

  setUtmData () {
    // UTM SOURCE
    if (this.utmResults.utm_source !== null) {
      window.mwfUtmData.utm_source = this.utmResults.utm_source;
    } else if (this.utmResults.gclid !== null) {
      window.mwfUtmData.utm_source = 'google';
    } else if (!window.mwfUtmData.utm_source && this.utmResults.referrer !== null) {
      window.mwfUtmData.utm_source = this.utmResults.referrer;
      window.mwfUtmData.utm_medium = 'referral';
    }

    // UTM MEDIUM
    if (this.utmResults.utm_medium !== null) {
      window.mwfUtmData.utm_medium = this.utmResults.utm_medium;
    } else if (this.utmResults.gclid !== null) {
      window.mwfUtmData.utm_medium = 'cpc';
    }

    // UTM CAMPAIGN
    if (this.utmResults.utm_campaign !== null) {
      window.mwfUtmData.utm_campaign = this.utmResults.utm_campaign;
    }

    // UTM CONTENT
    if (this.utmResults.utm_content !== null) {
      window.mwfUtmData.utm_content = this.utmResults.utm_content;
    }
  }
}
